import {
  Link,
  MESSAGE_BOX_VARIANT_DANGER,
  MessageBox,
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import React from 'react'
import { useIntl } from 'react-intl'

const ErrorFeedback = ({ error, onReload, className }) => {
  const intl = useIntl()

  return error ? (
    <MessageBox className={className} variant={MESSAGE_BOX_VARIANT_DANGER}>
      <span>{error}</span>{' '}
      {typeof onReload === 'function' && (
        <Link onClick={onReload}>
          {intl.formatMessage({ id: 'Load.Common.RealoadPage' })}
        </Link>
      )}
    </MessageBox>
  ) : null
}

ErrorFeedback.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onReload: PropTypes.func,
  className: PropTypes.string,
}

export default ErrorFeedback
